import {Color} from "./content";
import {Block} from "./block";

export enum NodeType {
  TEXT = 'text',
  HEADING_1 = 'heading_1',
  HEADING_2 = 'heading_2',
  HEADING_3 = 'heading_3',
  BULLETED_LIST_ITEM = 'bulleted_list_item',
  NUMBERED_LIST_ITEM = 'numbered_list_item',
  TOGGLE_ITEM = 'toggle_item',
  TO_DO_ITEM = 'to_do_item',
  IMAGE = 'image',
  ANCHOR = 'anchor',
  DIVIDER = 'divider',
  BREAK = 'br',
  PARAGRAPH = 'paragraph',
}

export type NodeMap = {
  [key in keyof NodeType]: Node[];
} & {
  checked?: boolean;
  title?: string;
  url?: string;
  children?: Block[];

};

export type Node = {
  [value in NodeType]: {
    content: string;
    link: {
      url: string;
      [key: string]: any;
    };
    source: string;
  };
} & {
  annotations: {
    bold: boolean;
    code: boolean;
    cite: boolean;
    color: Color;
    italic: boolean;
    strikethrough: boolean;
    underline: boolean;
  };
  href: string;
  plain_text: string;
  type: NodeType;
};
